<template>
    <div style="position: relative;">
        <div class="login login_fiexd" id='login' v-if='isFixed'>
            <div class="login_left" v-if="val_show" style="display: flex;align-items: center;">
                <van-icon name="arrow-left" @click="fh_arrow"/>
            </div>
            <div class="login_left" style="display: flex;align-items: center;">
                <img src="@/assets/img/logo_01.png" />
            </div>
            <div class="login_right">
                <img src="@/assets/img/login_01.png" />
                <span v-if="login_show" @click="attestation">未登录</span>
                <span v-else @click.prevent.self ="logins_showt">个人中心</span>
                <div class="E_head_right_nav_box" v-if="logins_show">
                    <div class="E_head_right_nav">
                        <div class="E_my_oderss E_head_right_nav_item">
                            <a href="/m/user">
                            个人中心
                            </a>
                        </div>
                        <div class="E_my_oder E_head_right_nav_item">
                            <a href="/m/home/my/order">
                            我的订单
                            </a>
                        </div>
                        <div class="E_my_card E_head_right_nav_item">
                            <a href="/m/shopping">
                                购物车
                            </a>
                        </div>
                        <div class="E_my_oders E_head_right_nav_item">
                            <a href="javascript:;" id="logout"  @click="attedele">
                                退出登录
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="login" id='login' v-else>
            <div class="login_left" v-if="val_show" style="display: flex;align-items: center;">
                <van-icon name="arrow-left" @click="fh_arrow"/>
            </div>
            <div class="login_left" style="display: flex;align-items: center;">
                <!-- <img src="@/assets/img/logo.png" /> -->
            </div>
            <div class="login_right">
                <img src="@/assets/img/login_01.png" />
                <span v-if="login_show" @click="attestation">未登录</span>
                <span v-else @click.prevent.self ="logins_showt">个人中心</span>
                <div class="E_head_right_nav_box" v-if="logins_show">
                    <div class="E_head_right_nav">
                        <div class="E_my_oderss E_head_right_nav_item">
                            <a href="/m/user">
                            个人中心
                            </a>
                        </div>
                        <div class="E_my_oder E_head_right_nav_item">
                            <a href="/m/home/my/order">
                            我的订单
                            </a>
                        </div>
                        <div class="E_my_card E_head_right_nav_item">
                            <a href="/m/shopping">
                                购物车
                            </a>
                        </div>
                        <div class="E_my_oders E_head_right_nav_item">
                            <a href="javascript:;" id="logout"  @click="attedele">
                                退出登录
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import { Dialog } from 'vant';
    import Cookie from 'js-cookie'
    var than;
    export default {
        name: "home",
        data() {
            return {
                login_show: true,
                val_show: false,
                isFixed: false,
                logins_show: false,
            };
        },
        props:['fh'],
        created() {
            than = this;
        $.get(window.location.origin + '/m/session/login', { }, function(res) {
                function getUrlParam(name) {
                    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)'); //构造一个含有目标参数的正则表达式对象
                    var r = window.location.search.substr(1).match(reg); //匹配目标参数
                    if (r != null) return unescape(r[2]);
                    return null; //返回参数值
                }
                var sign = getUrlParam('sign');
                if(Cookie.get("api_token") == null || Cookie.get("api_token") == "") {
                    than.login_show = true;
                    localStorage.removeItem('api_token')
                    localStorage.setItem('sign', sign);
                    localStorage.removeItem('token')
                }else {
                    sign = Cookie.get("api_token")
                    localStorage.setItem("token", Cookie.get("api_token"))
                    localStorage.setItem("api_token", Cookie.get("api_token"))
                    than.login_show = false;
                }

                document.addEventListener("click", (e) => {
                    if (!than.$el.contains(e.target)) {
                        than.logins_show = false; //点击其他区域关闭
                    }
                });
            });
        },
        watch:{
        },
        methods:{
            logins_showt(e) {
                e.sto
                this.logins_show = !this.logins_show
            },
            handleScroll(){
            　　let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
            　　let offsetTop = document.querySelector('#login').offsetTop; // 要滚动到顶部吸附的元素的偏移量
            　　this.isFixed = scrollTop > 200 ? true : false; // 如果滚动到顶部了，this.isFixed就为true
            },
            fh_arrow() {
                this.$router.back()
            },
            attestation () {
                // window.location.href = 'https://lanhuapp.com/web/#/item/project/stage?tid=908e6dfc-a318-43b8-8d1b-b443869f87ee&pid=5d866054-a9f8-405e-aab1-ac8ac0dc1b24'
                // this.loginShow = true
                Dialog.confirm({
                    title: '还没有登录哦~ 是否跳转登录',
                    message: ''
                }).then(() => {
                    var host = window.location.href.replace(/#/g,"vue")
                    window.location.href = window.location.origin + '/m/login?turn_jump_url=' + host;
                })
                .catch(() => {});
            },
            attedele() {
                Dialog.confirm({
                    title: '是否退出登录',
                    message: ''
                }).then(() => {
                    $.get(window.location.origin +'/m/logout',
                    function(res) {
                        if (res.code == 1) {
                            than.$forceUpdate()
                            localStorage.removeItem('api_token');
                            localStorage.removeItem('token');
                            Cookie.set("api_token", "")
                            than.login_show = true
                            location.reload();
                            than.$toast(res.msg);
                        }
                    }
                );
                })
                .catch(() => {});
               
            },
        },
        mounted() {
            window.addEventListener('scroll',this.handleScroll)
            if(this.fh == 1) {
                this.val_show = true
            }
        },
        components: {
        },
    };
</script>

<style lang="less" scoped>
    .login {
      height: 1rem;
      display: flex;
      justify-content: space-between;
      position: fixed;
      top: 0;
      width: 7.5rem;
      left: 0;
      right: 0;
      margin: auto;
      padding: 0rem .27rem;
      padding-right: 0;
      z-index: 2;
      .login_left {
        img {
          width: 1.48rem;
        }

        >i {
            color: #FFF;
            font-size: .4rem;
        }
      }

      > .login_right {
        display: flex;
        align-items: center;
        position: relative;
        
        > img {
          width: 0.57rem;
          height: 0.57rem;
          background: #FFFFFF;
          border-radius: 50%;
          position: absolute;
          left: 0;
        }

        > span {
          width: 1.84rem;
          overflow: hidden;
          height: 0.52rem;
          display: block;
          text-indent: .6rem;
          line-height: .52rem;
          border: 1px solid #E6F2FF;
          border-right: none;
          border-radius: 0.26rem 0 0 .26rem ;
          background: rgba(230, 242, 255, .3);

          font-size: 0.26rem;
          color: #FFFFFF;
        }
      }
    }

  .home_body {
    width: 7.5rem;
    height: 12.77rem;
    background: url('../../assets/img/index_01.png') center center no-repeat;
    background-size: 7.5rem 12.77rem;
  }

  .login_fiexd {
      height: 1rem;
      background: #FFF;
      box-shadow: 0 0 8px rgba(0, 0, 0, .1);
       .login_left {
        >i {
            color: #000;
            font-size: .4rem;
        }
      }
      > .login_right {
        
        > img {
        }

        > span {
          width: 1.84rem;
          overflow: hidden;
          height: 0.52rem;
          display: block;
          text-indent: .6rem;
          line-height: .52rem;
          border: 1px solid #E6F2FF;
          border-right: none;
          border-radius: 0.26rem 0 0 .26rem ;
          background: rgba(230, 242, 255, .3);

          font-size: 0.26rem;
          color: #000;
        }
      }
  }

.E_head_right_nav_box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
    background-color: #fff;
    &::after {
        content: "";
        position: absolute;
        margin-left: -0.375rem;
        top: -0.2rem;
        right: 0.04rem;
        width: 0;
        height: 0;
        border-width: 0.1rem 0.15rem 0.15rem 0.15rem;
        border-style: solid;
        border-color: transparent transparent #fff transparent;
    }
    .E_head_right_nav {
        width: 2.41rem;
        height: auto;
        background: #FFFFFF;
        box-shadow: -0.11rem 0.13rem 0.61rem 0.03rem rgba(71, 76, 100, 0.2);
        border-radius: 0.1rem;
        .E_head_right_nav_item {
            justify-content: center;
            flex-direction: row;
            justify-items: center;
            height: 0.8rem;
            width: 100%;
            border-bottom: 1px solid #E1E2E6;
            display: flex;
            align-items: center;
            a {
                width: 100%;
                height: 100%;
                text-align: center;
                display: block;
                font-size: 0.3rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #000000;
                line-height: 0.8rem;
            }
        }
    }
}
</style>
